import { Divider, Form } from "antd";
import React, { useState } from "react";
import ModalComponent from "../../../../components/ModalComponent";
import ToySelect from "./toySelect";

const GenresAddToyTable = ({
  setGenreToySelectModalOpen,
  genreToySelectModalOpen,
  genreId,
  onFinish,
  loadings,
  setToySelectValue,
}) => {
  const [form] = Form.useForm();
  const [isValidateTrigger, setIsValidateTrigger] = useState(false);
  const { Item } = Form;
  const handleCancel = () => {
    setGenreToySelectModalOpen(false);
    form?.resetFields();
  };
  return (
    <>
      <ModalComponent
        open={genreToySelectModalOpen}
        onCancel={handleCancel}
        onOk={form?.submit}
        title='Add New Toys'
        okText="Save"
        confirmLoading={loadings}
        destroyOnClose
        forceRender
      >
        <Divider />
        <Form
          form={form}
          onFinish={(values) => {
            onFinish(values);
            setIsValidateTrigger(true);
            handleCancel(values);
          }}
          autoComplete="off"
          layout="vertical"
          validateTrigger={isValidateTrigger ? 'onChange' : 'onSubmit'}
          onFinishFailed={() => setIsValidateTrigger(true)}
        >
          <Item label="Toys" name="toyIds">
            <ToySelect
              genreId={genreId}
              onChange={(values) => setToySelectValue(values)}
            />
          </Item>
        </Form>
      </ModalComponent>
    </>
  )
}

export default GenresAddToyTable